<template>
  <div class="report-card">
    <div class="report-card__header">
      <h5>
        <fa
          aria-hidden="true"
          icon="check-circle"
          class="icon"
          v-if="successIcon"
        ></fa
        >{{ header }}
      </h5>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['header', 'image', 'buttonText', 'text', 'successIcon']
};
</script>

<style lang="scss" scoped>
.report-card {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  padding: 16px;
  margin: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 435px;
  justify-content: flex-start;
  min-width: 320px;

  @media screen and (max-width: 440px) {
    min-width: 280px;
    width: 100%;
    margin: 0;
    padding: 8px;
  }

  h5 {
    margin: 0;
    min-height: 48px;

    @media screen and (max-width: 440px) {
      font-size: 16px;
    }
  }

  img {
    max-width: 280px;
  }
  button {
    margin: 16px 0;
  }
  .text {
    text-align: center;
  }

  .icon {
    color: #208836;
    margin-right: 4px;
  }
}
</style>
